<template>
  <v-card class="order-card elevation-hb" :style="cssVars + ';height: 100%'">
    <v-card-title class="header-dash sub">
      <v-icon class="sub mg" v-if="icon">{{icon}}</v-icon>
      {{title}}
    </v-card-title>
    <div class="pa-5">      
      <slot></slot>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "OrderCard",
  props: ["title", "icon", "header", "color"],
  computed: {
    cssVars() {
      return { "--border-color": this.color }
    }
  }
}
</script>

<style scoped>
.header-dash {
  border-bottom: 2px solid #efefef !important;
}

.sub {
  color: #455a64;
  margin-right: 10px !important;
}

.order-card {
  font-size: 10pt;
  height: 100%;
  color: #455a64;
}
</style>